import React from "react";
import { PATH_GARANTE_PRIVACY } from "../../../path";

export const enInformativa = (
  <>
    <h1>INFORMATION ON THE PROCESSING OF PERSONAL DATA through the use of the APP SURGERY TRACKER</h1>
    <h2>of IRCCS Ospedale Policlinico San Martino pursuant to Article 13 of Regulation (EU) 2016/679</h2>
    <span>
      <p>
        Before proceeding to the processing of data, as required by Article 13 of Regulation (EU) 2016/679 of the
        European Parliament and of the Council of 27 April 2016 (GDPR), we inform you that the personal data provided
        are subject to processing, both in paper and in electronic form for the purposes indicated below.
      </p>
      <h3>Data controller</h3>
      <p>
        The Data Controller is IRCCS Ospedale Policlinico San Martino (hereinafter referred to as the "Data
        Controller"), with headquarters in Largo Rosanna Benzi 10 - 16132 Genoa. In this capacity it is responsible for
        guaranteeing the application of the organisational and technical measures necessary and appropriate for the
        protection of personal data.
      </p>
      <h3>Data Protection Officer</h3>
      <p>
        The Data Controller has appointed a Data Protection Officer (hereinafter referred to as "DPO"), pursuant to
        Articles 37 et seq. of the Regulation, who can be contacted at the following email address:{" "}
        <a href="mailto:dpo@hsanmartino.it">dpo@hsanmartino.it</a>
      </p>
      <h3>Purposes and legal basis of the processing</h3>
      <p>
        Personal data will be processed for the purposes described below in accordance with current privacy legislation,
        and the Data Controller therefore undertakes to process them in accordance with the principles of correctness,
        lawfulness and transparency, in compliance with the purposes indicated below, collecting them to the extent
        necessary and accurate for processing, and using them only by staff authorised for that purpose.
        <br />
        The purpose of the processing of personal data is the use of the SURGERY TRACKER web app.
        <br />
        For the purpose described above, the lawful basis for processing is found in Art. 6 para. 1 letter e) GDPR, i.e.
        in the performance of tasks carried out in the public interest or in any case connected with the exercise of
        public authority.
      </p>
      <h3>Categories of personal data</h3>
      <p>
        It should be noted that the services provided by the SURGERY TRACKER web app, as well as its features and
        functions, do not require any form of user registration. However, the computer systems and software procedures
        used to operate this web app acquire, in the course of their normal operation, some personal data whose
        transmission is implicit in the use of Internet communication protocols.
        <br />
        This category of data includes the IP addresses or domain names of the computers and terminals used by users,
        the Uri/Url (Uniform Resource Identifier/Locator) addresses of the resources requested, the time of the request,
        the method used to submit the request to the server, the size of the file obtained in response, the numerical
        code indicating the status of the response given by the server (successful, error, etc.) and other parameters
        relating to the user's operating system and computer environment.
        <br />
        The data processed in order to pursue the above-mentioned purpose are:
      </p>
      <ul>
        <li>Browser fingerprint</li>
        <li>Model make and resolution/size of device</li>
        <li>Internet browsing data</li>
      </ul>
      <h3>Processing methods and data storage period</h3>
      <p>
        Personal data are processed by automated and manual tools for the time strictly necessary to achieve the
        purposes for which they were collected. Specific security measures are observed to prevent data loss, illicit or
        incorrect use and unauthorised access.
      </p>
      <p>Navigation data are not stored for more than seven days.</p>
      <h3>Scope of knowability of data</h3>
      <p>
        Personal data may also be shared, for the above-mentioned purposes, with the following categories of subjects:
      </p>
      <ul>
        <li>Persons authorised to process the data by the Data Controller;</li>
        <li>
          Data processors, such as persons who may be appointed by the Data Controller for specific - processing
          activities.
        </li>
      </ul>
      <h3>Data transfer abroad</h3>
      <p>There are no transfers of personal data to third countries (outside the EU) or international organisations.</p>
      <h3>Rights of the interested parties</h3>
      <p>
        The interested parties have the right to obtain from the Data Controller, in the cases provided for, access to
        their personal data and the rectification or cancellation thereof or the restriction of processing concerning
        them or to object to processing (Art. 15 et seq. of the Regulation).
        <br />
        In order to exercise these rights at the Ospedale Policlinico San Martino you will have to fill in a specific
        petition that can be:
      </p>
      <ol style={{ listStyleType: "lower-alpha" }}>
        <li>Personally delivered to the Protocol Office (Administration Building, ground floor), or</li>
        <li>
          Sent by recorded delivery letter to the following address Ufficio Protocollo Ospedale Policlinico San Martino
          - Largo Rosanna Benzi 10, 16132 - Genova or
        </li>
        <li>
          Sent by PEC to <a href="mailto:protocollo@pec.hsanmartino.it">protocollo@pec.hsanmartino.it</a> with the
          following message in the subject line: Privacy exercise of rights.
        </li>
      </ol>
      <p>
        The interested party may also lodge a complaint with a Supervisory Authority (Italian Data Protection Authority
        –{" "}
        <a href={PATH_GARANTE_PRIVACY} target="_blank" rel="noopener noreferrer">
          www.garanteprivacy.it
        </a>
        ).
      </p>
    </span>
  </>
);
